import { ContentSection } from '@src/components/content-section';
import { TableOfContents } from '@src/components/table-of-contents';
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

//Images
import apiKey from '@public/img/setup/rentman-api-key.png';
import webhook from '@public/img/setup/rentman-guide.jpg';
import insertWebhook from '@public/img/setup/rentman-webhook-token.png';
import applicationClientIdInsert from '@public/img/setup/application-client-id-insert.png';
import goToEntraId from '@public/img/setup/1go-to-entra-ID.png';
import goToAppRegistrations from '@public/img/setup/2go-to-app-registrations.png';
import pressNewRegistration from '@public/img/setup/3press-new-registration.png';
import enterInformationRegisterApp from '@public/img/setup/4enter-information-register-app.png';
import pressRegisterAppButton from '@public/img/setup/5press-register-button.png';
import applicationDirectoryId from '@public/img/setup/6appilcation-directory-id.png';
import addClientSecret from '@public/img/setup/7add-client-secret.png';
import clientSecretFields from '@public/img/setup/8description-expires.png';
import clientSecretValue from '@public/img/setup/10get-client-secret-value.png';
import clientSecretInsert from '@public/img/setup/client-secret-insert.png';
import searchIcon from '@public/img/setup/11search-icon.png';
import microsoftEntra from '@public/img/setup/12microsoft-entra.png';
import newEntra from '@public/img/setup/13create-new-entra.png';
import enterApplicationAndTenant from '@public/img/setup/14enter-application-tenant-id.png';
import apiPermissions from '@public/img/setup/21api-permissions.png';
import addPermission from '@public/img/setup/22add-permission.png';
import bcPermission from '@public/img/setup/23select-bc-api.png';
import delegatedPermissions from '@public/img/setup/24delegated-permissions.png';
import permissionsInDelegated from '@public/img/setup/25permissions-in-delegated.png';
import applicationPermissions from '@public/img/setup/26application-permissions.png';
import permissionsInApplication from '@public/img/setup/27permissions-in-application.png';
import giveApiPermissions from '@public/img/setup/28-give-api-perms.png';
import saveConnection from '@public/img/setup/36save-connection.png';
import selectIntegrationCompany from '@public/img/setup/37select-company.png';
import extensionManagementSearch from '@public/img/setup/udvidelsesstyring.png';
import uploadExtension from '@public/img/setup/upload-udvidelse.png';
import entraApplicationsSearch from '@public/img/setup/entra-til-extension.png';
import configurationTemplatesSearch from '@public/img/setup/Konfigurationstabeller.png';
import configurationTemplateExample from '@public/img/setup/Konfigurationstabel_example.png';
import configurationTemplates from '@public/img/setup/Konfigurationstabeller_rows.png';
import euConfigurationTemplate from '@public/img/setup/EU_konfigurationstabel.png';
import rowConfigurationTemplate from '@public/img/setup/ROW-konfigtabel.png';

export const SetupPage: React.FC = () => {
  const contents = [
    {
      title: '1. API key integration',
      anchor: 'api-integration',
      content: [
        'To integrate your API key from Rentman, navigate to ',
        { bold: true, text: 'Integration > Connections ' },
        'or ',
        { link: '../connection-config', text: 'press this link' },
        '\n You can find a guide on how to generate an ',
        { link: 'https://support.rentman.io/hc/en-us/articles/360013767839-The-Rentman-API', text: 'API key from rentman here.' },
        { imageSrc: apiKey },
      ],
    },
    {
      title: '2. Activate webhooks',
      anchor: 'activate-webhooks',
      content: ['To activate webhooks in Rentman, you have to contact the ', { link: 'https://support.rentman.io/hc/en-us', text: 'Rentman Support Center' }],
    },
    {
      title: '3. Adjust webhook settings',
      anchor: 'adjust-webhook-settings',
      content: [
        'Adjust webhook settings by inserting this URL: ',
        { link: 'https://rentman-dynamics.ey.r.appspot.com/rentman/hook', text: 'https://rentman-dynamics.ey.r.appspot.com/rentman/hook' },
        ' and then pressing save.',
        { imageSrc: webhook },
      ],
    },
    {
      title: '4. Insert webhook token',
      anchor: 'insert-webhook-token',
      content: [
        'Copy your webhook token and insert it into the Rentman form field under ',
        { bold: true, text: 'Integration > Connections \n' },
        { imageSrc: insertWebhook },
      ],
    },
    {
      title: '5. Application (client) ID and Directory (tenant) ID',
      anchor: 'application-directory-id-setup',
      content: [
        '1. Navigate to your azure portal account at ',
        { link: 'https://portal.azure.com', text: 'https://portal.azure.com' },
        ', and press the',
        { bold: true, text: ' Microsoft Entra ID ' },
        'in the left-hand menu.',
        { imageSrc: goToEntraId },
        '2. Select App registrations in the left-hand menu',
        { imageSrc: goToAppRegistrations },
        '3. Press the ',
        { bold: true, text: 'New registration ' },
        'button.',
        { imageSrc: pressNewRegistration },
        '4. Enter the following values into the fields: ',
        { list: ['Name: Rentman - Business Central', 'Redirect URI: Single-page application (SPA) + https://businesscentral.dynamics.com/OAuthLanding.htm'] },
        { imageSrc: enterInformationRegisterApp },
        '5. Press the ',
        { bold: true, text: 'Register ' },
        'button',
        { imageSrc: pressRegisterAppButton },
        '6. After registering the app, you are presented with your ',
        { bold: true, text: 'Application (client) ID ' },
        'and ',
        { bold: true, text: 'Directory (tenant) ID' },
        { imageSrc: applicationDirectoryId },
        '7. Enter these values into the IT Stack integration under ',
        { bold: true, text: 'Integration > Connections' },
        { imageSrc: applicationClientIdInsert },
        { bold: true, text: 'NOTE: ' },
        'These values will not work yet, but that will be covered later in the guide.',
      ],
    },
    {
      title: '6. Client Secret',
      anchor: 'client-secret-setup',
      content: [
        '1. Head back to the azure portal, and press the ',
        { bold: true, text: 'Add a certificate or secret ' },
        'button. ',
        { imageSrc: addClientSecret },
        '2. Enter the following values in the fields: ',
        { list: ['Description: Rentman BC Client secret', 'Expires: 730 days'] },
        'And press the ',
        { bold: true, text: 'Add ' },
        'button.',
        { imageSrc: clientSecretFields },
        '3. After adding your secret, you will be presented with your client ',
        { bold: true, text: 'Value ' },
        'and ',
        { bold: true, text: 'Secret ID ' },
        'copy the ',
        { bold: true, text: 'Value' },
        { imageSrc: clientSecretValue },
        '4. Add this to the IT Stack integration under ',
        { bold: true, text: 'Integration > Connections' },
        { imageSrc: clientSecretInsert },
        { bold: true, text: 'NOTE: ' },
        'This value will not work yet, but that will be covered later in the guide.',
      ],
    },
    {
      title: '7. Add the Microsoft Entra application in Business Central',
      anchor: 'business-central-permissions',
      content: [
        '1. Log in to your business central account on ',
        { link: 'https://businesscentral.dynamics.com/', text: 'https://businesscentral.dynamics.com/' },
        ' and press the search icon in the top-right corner.',
        { imageSrc: searchIcon },
        '2. Search for ',
        { bold: true, text: 'entra ' },
        'and select ',
        { bold: true, text: 'Microsoft Entra-programmer' },
        { imageSrc: microsoftEntra },
        '3. Press the ',
        { bold: true, text: 'Ny ' },
        'button',
        { imageSrc: newEntra },
        '4. Enter the following values into the fields, some of which were entered in the integration earlier: ',
        {
          list: [
            'Klient-id: {your-application-(client)-id}',
            'App-id: {your-directory-(tenant)-id}',
            'Beskrivelse: Dynamics BC Integration',
            'Appnavn: Dynamics BC Integration',
          ],
        },
        { imageSrc: enterApplicationAndTenant },
        '5. Leave the application disabled for now. Its permission set is installed with the extension in step 9 and assigned in step 10.',
      ],
    },
    {
      title: '8. Azure API Permissions',
      anchor: 'azure-api-permissions',
      content: [
        '1. Head back to your Azure Portal at ',
        { link: 'https://portal.azure.com', text: 'https://portal.azure.com' },
        ', and select ',
        { bold: true, text: 'API permissions ' },
        'in the left-hand menu',
        { imageSrc: apiPermissions },
        '2. Press the ',
        { bold: true, text: 'Add a permission ' },
        'button',
        { imageSrc: addPermission },
        '3. Select the ',
        { bold: true, text: 'Dynamics 365 Business Central ' },
        'API permissions.',
        { imageSrc: bcPermission },
        '4. Press the ',
        { bold: true, text: 'Delegated permissions ' },
        'button.',
        { imageSrc: delegatedPermissions },
        '5. Select the permissions as shown on the image, and press the ',
        { bold: true, text: 'Add permissions ' },
        'button.',
        { imageSrc: permissionsInDelegated },
        '6. Press the ',
        { bold: true, text: 'Application permissions ' },
        'button',
        { imageSrc: applicationPermissions },
        '7. Select the permissions as shown on the image, and press the ',
        { bold: true, text: 'Add permissions ' },
        'button',
        { imageSrc: permissionsInApplication },
        '8. Once you have configured the permissions, press the ',
        { bold: true, text: 'Grant admin consent ' },
        'button',
        { imageSrc: giveApiPermissions },
      ],
    },
    {
      title: '9. Install the Rentman Integration Extension',
      anchor: 'install-contact-extension',
      content: [
        'Download the extension used to assign the selected Rentman contact person as the customer primary contact in Business Central: ',
        { link: '/downloads/rentman-integration-extension.app', text: 'Download Rentman Integration Extension 1.0.0.5' },
        '.',
        '1. Sign in to the Business Central environment that the integration will use. Search for ',
        { bold: true, text: 'Extension Management' },
        ' and open the page.',
        { imageSrc: extensionManagementSearch },
        '2. Open ',
        { bold: true, text: 'Manage' },
        ' and select ',
        { bold: true, text: 'Upload Extension' },
        '.',
        { imageSrc: uploadExtension },
        '3. Select the downloaded .app file and use these installation settings:',
        {
          list: ['Install for: Current version', 'Schema sync mode: Add', 'Choose the required language and confirm the installation'],
        },
        '4. Verify that ',
        { bold: true, text: 'Rentman Integration Extension' },
        ' version ',
        { bold: true, text: '1.0.0.5' },
        ' is installed. The extension does not require outgoing HttpClient requests.',
      ],
    },
    {
      title: '10. Assign the integration permission set',
      anchor: 'contact-extension-permissions',
      content: [
        '1. Search for ',
        { bold: true, text: 'Microsoft Entra applications' },
        ' in Business Central and open the application configured in step 7.',
        { imageSrc: entraApplicationsSearch },
        '2. Make sure the application is disabled before editing its permission sets.',
        '3. Under ',
        { bold: true, text: 'User Permission Sets' },
        ', add one row and select ',
        { bold: true, text: 'RENTMAN INTEGRATION' },
        '. Select the company that the integration will use.',
        '4. Do not assign ',
        { bold: true, text: 'D365 FULL ACCESS' },
        ' or ',
        { bold: true, text: 'RENTMAN CONTACT' },
        ' separately. RENTMAN INTEGRATION already includes the required customer, contact, item, sales-document and setup-table access.',
        '5. Confirm that the application card contains the same values as the example:',
        {
          list: [
            'Client ID: the Application (client) ID from step 5',
            'Description: Dynamics BC Integration',
            'App ID: the Directory (tenant) ID from step 5',
            'Permission Set: RENTMAN INTEGRATION',
            'Company: the Business Central company used by the integration',
          ],
        },
        'The Client Secret remains configured under Integration > Connections as described in step 6.',
        '6. Enable the application and press ',
        { bold: true, text: 'Grant Consent' },
        '.',
      ],
    },
    {
      title: '11. Create customer configuration templates',
      anchor: 'customer-configuration-templates',
      content: [
        'New customers receive posting groups and currency from Business Central templates. These values are no longer sent through published OData pages.',
        '1. Search for ',
        { bold: true, text: 'Configuration Templates' },
        ' and open the page.',
        { imageSrc: configurationTemplatesSearch },
        '2. Create a template with table ID ',
        { bold: true, text: '18' },
        ' (Customer). Add the required fields as template lines, then enable the template.',
        { imageSrc: configurationTemplateExample },
        '3. Create these three templates:',
        {
          list: [
            'CUST-DK: Danish customers. Leave Currency Code blank to use the local DKK currency.',
            'CUST-EU: EU customers outside Denmark. Use Currency Code EUR.',
            'CUST-ROW: customers outside the EU. Use Currency Code USD.',
          ],
        },
        { imageSrc: configurationTemplates },
        '4. Each template must include ',
        { bold: true, text: 'Customer Posting Group' },
        ', ',
        { bold: true, text: 'Gen. Bus. Posting Group' },
        ' and ',
        { bold: true, text: 'VAT Bus. Posting Group' },
        '. The codes shown in the screenshots are examples; select codes that exist in the customer environment.',
        { imageSrc: euConfigurationTemplate },
        { imageSrc: rowConfigurationTemplate },
      ],
    },
    {
      title: '12. Assign templates in API Setup',
      anchor: 'customer-api-setup',
      content: [
        '1. Search for ',
        { bold: true, text: 'API Setup' },
        ' in Business Central and add three rows:',
        {
          list: [
            'Sequence 10 — Table ID 18 — Page ID 30009 — Template CUST-DK',
            'Sequence 20 — Table ID 18 — Page ID 30009 — Template CUST-EU',
            'Sequence 30 — Table ID 18 — Page ID 30009 — Template CUST-ROW',
          ],
        },
        '2. Open ',
        { bold: true, text: 'Conditions' },
        ' for each row and add a filter on ',
        { bold: true, text: 'Country/Region Code' },
        ':',
        {
          list: [
            'CUST-DK: DK',
            'CUST-EU: AT|BE|BG|HR|CY|CZ|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE',
            'CUST-ROW: <>AT&<>BE&<>BG&<>HR&<>CY&<>CZ&<>DK&<>EE&<>FI&<>FR&<>DE&<>GR&<>HU&<>IE&<>IT&<>LV&<>LT&<>LU&<>MT&<>NL&<>PL&<>PT&<>RO&<>SK&<>SI&<>ES&<>SE',
          ],
        },
        '3. Verify that the required combinations of customer VAT business posting groups and item VAT product posting groups exist in ',
        { bold: true, text: 'VAT Posting Setup' },
        '. A valid ISO Country/Region Code is required for the correct template to be selected.',
      ],
    },
    {
      title: '13. Select company',
      anchor: 'select-company',
      content: [
        '1. After setting up all of the above, head to ',
        { bold: true, text: 'Integration > Connections ' },
        'in the IT Stack integration, and press the save button',
        { imageSrc: saveConnection },
        '2. Select your company from the dropdown, and press save again',
        { imageSrc: selectIntegrationCompany },
        '3. Create a test invoice and verify the customer posting groups, currency, payment terms and selected contact person in Business Central.',
        { bold: true, text: 'You are now able to use the integration!' },
      ],
    },
  ];

  return (
    <Card className="mt-4">
      <Card.Header>Setup guide</Card.Header>
      <Card.Body>
        <Row>
          <Col className="toc-col">
            <div className="toc-container">
              <TableOfContents sections={contents}></TableOfContents>
            </div>
          </Col>
          <Col lg={9}>
            {contents.map((content) => (
              <div className="content-section" key={content.anchor} id={content.anchor}>
                <ContentSection {...content} />
              </div>
            ))}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
